import React, { useEffect, useRef } from "react";

import { ReactComponent as Spinner } from "../../_assets/imgs/spinner-solid.svg";

import "./camera-diagnostic.styles.css";

const CameraDiagnostic = ({ status, index, changeDiagnosticResults }) => {
  const vidPlayerRef = useRef(null);

  // const pause = ()=>{
  //   return new Promise((resolve,reject)=>{
  //     setTimeout(()=>{resolve()},5000)
  //   })
  // }

  const checkCamera = async () => {
    const mediaSupport = "mediaDevices" in navigator;
    if (!mediaSupport)
      changeDiagnosticResults(
        index,
        "Browser does not support camera",
        "error"
      );

    try {
      const streams = await navigator.mediaDevices.getUserMedia({
        audio: true,
        video: true,
      });
      if (
        streams.getVideoTracks().length > 0 &&
        streams.getAudioTracks().length > 0
      ) {
        vidPlayerRef.current.srcObject = streams;
        vidPlayerRef?.current?.play();
        // await pause();
        changeDiagnosticResults(index, "Working", "successful");
        // return streams.getTracks().forEach((track) => {
        //   track.stop();
        // });
      } else {
        changeDiagnosticResults(index, "No Camera Detected", "error");
      }
    } catch (err) {
      console.log(err);
      changeDiagnosticResults(index, err.message, "error");
    }
  };
  useEffect(() => {
    if (status === "error" || status === "successful" || status === "pending")
      return;
    checkCamera();
  }, [status]); // eslint-disable-line react-hooks/exhaustive-deps
  return (
    <div className="diagnostic-details-wrapper">
      <span>
        {status === "running" && <Spinner className="diagnostic-spinner" />}
      </span>
      {status === "successful" && (
        <span className="diagnostic-tick">&#10003;</span>
      )}
      {status === "error" && <span className="diagnostic-error">!</span>}
      <div>
        <span className="diagnostic-test-heading">Camera Test</span>
        <video className="camera-player" ref={vidPlayerRef} />
        <div className="diagnostics-question-wrapper"></div>
        <div></div>
        <span>If you are getting an error try these steps: </span>
        <ul>
          <li>Check your external camera</li>
          <li>Try refreshing page</li>
          <li>Check camera permissions</li>
        </ul>
        <span className="camera-diagnostics-bold">Having trouble? </span>
        <span className="camera-diagnostics-link">
          Check our diagnostic guide
        </span>
      </div>
    </div>
  );
};

export default CameraDiagnostic;
